// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"152":"invite","443":"about"}[chunkId] || chunkId) + "." + {"152":"4909dd00","272":"5edddef0","443":"fc4c76ba","880":"2dbc0b8d"}[chunkId] + ".css";
};